define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrUsageCond = void 0;
    class SrCrUsageCond extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "CrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Condition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SrCrUsageCond.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.SrCr = parent;
            this.CrId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.SrCr = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.CrId = (0, EntityUtil_1.toInt)(entity.CrId);
            a.Condition = b.Condition;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SrCrUsageCond.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                CrId: this.CrId,
                Condition: this.Condition,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(cr) {
            return new Promise((resolve, reject) => {
                let x = new SrCrUsageCond(null, cr);
                x.Condition = "Type condition here";
                cr.SrCrUsageCond.push(x);
                resolve(x);
            });
        }
    }
    exports.SrCrUsageCond = SrCrUsageCond;
    Object.defineProperty(SrCrUsageCond, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SrCrUsageCond"
    });
    Object.defineProperty(SrCrUsageCond, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SRN Change Request Usage Condition"
    });
    Object.defineProperty(SrCrUsageCond, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "CrId", "Condition"]
    });
    Object.defineProperty(SrCrUsageCond, "CrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrUsageCond, "ConditionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCrUsageCond, "ConditionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the condition that will now apply for all activities on this Stock Route"
    });
    Object.defineProperty(SrCrUsageCond, "ConditionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrUsageCond.prototype, "CrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrUsageCond.prototype, "CrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrUsageCond.prototype, "Condition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrUsageCond.prototype, "ConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrUsageCond.prototype, "SrCr", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrUsageCond.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrUsageCond.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrUsageCond.prototype, "merge", null);
});
